import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { PipelineLicenseCategoryDto, PipelineLicenseStageDto } from '@cradua/data';
import { Observable } from 'rxjs/internal/Observable';
import { routeAnimations, ROUTE_ANIMATIONS_ELEMENTS } from 'libs/core/src/lib/animations';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';

@Component({
  selector: 'cradua-pipeline-license-stage-container',
  templateUrl: './pipeline-license-stage-container.component.html',
  styleUrls: ['./pipeline-license-stage-container.component.scss']
})
export class PipelineLicenseStageContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  pipelinelicensecategoryes$: Observable<PipelineLicenseCategoryDto[]>;
  pipelinelicensestages$: Observable<PipelineLicenseStageDto[]>;
  loading: boolean;
  isPipelineLicenseCategoryLoading$: Observable<any>;
  isLoading$:  Observable<any>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isPipelineLicenseCategoryLoading$ = this.gatwayFacade.isLoadingGateway("PipelineLicenseCategory");
    this.pipelinelicensecategoryes$ = this.gatwayFacade.loadGateway("PipelineLicenseCategory");
    this.isLoading$ = this.gatwayFacade.isLoadingGateway("PipelineLicenseStage");
    this.pipelinelicensestages$ = this.gatwayFacade.loadGateway("PipelineLicenseStage");
    this.pipelinelicensestages$.subscribe(data => {
      console.log("data: cont.",data);
    })
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeletePipelineLicenseStage(deletedValue: any) {
    this.gatwayFacade.remove("PipelineLicenseStage", deletedValue);
    // this.store.dispatch(PipelineLicenseStageStoreActions.removePipelineLicenseStage({ids: deletedValue}));
    this.notificationService.success('Deleted Successfully');
  }

// this method control both the create and update
  onSubmitPipelineLicenseStage(formValue: any) {
    console.log("form value: ", formValue);
    formValue.PipelineLicenseStages = formValue.PipelineLicenseStages.reverse();
    event.preventDefault();
    const pullData = formValue.PipelineLicenseStages;
    //const newPullData = formValue.PipelineLicenseStagees;

// declare two empty array to hold update and create data
  let allUpdates = [] ;
  let addAllPipelineLicenseStage = [];

// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id) {
      allUpdates.push(pullData[i]);
    } else {
      console.log("without id: ", pullData);
      addAllPipelineLicenseStage.push(pullData[i]);
    }
  }

// check if the addAllPipelineLicenseStage array is not empty, then dispatch the data to the store
   if(addAllPipelineLicenseStage.length !== 0) {
    this.gatwayFacade.add('PipelineLicenseStage', addAllPipelineLicenseStage);
    // this.store.dispatch(PipelineLicenseStageStoreActions.addPipelineLicenseStage({newPipelineLicenseStage: addAllPipelineLicenseStage}));
   }

// dispatch update data to the store
    this.gatwayFacade.update('PipelineLicenseStage', allUpdates, ['id']);
    // this.store.dispatch(PipelineLicenseStageStoreActions.updatePipelineLicenseStage({updatePipelineLicenseStage: allUpdates}));
    this.notificationService.success('Saved Successfully');
  }
}
